import React from "react";
import { useTranslation } from "react-i18next";
import InputHeader from "../../InputHeader"
import CompanyFields from "./Company"
import DepartmentsFields from "../department/DepartmentsFields"
import UserFields from "../user/UserFields"

interface IInputSectionProps {
    requireCompanyData?: boolean;
    isPolishCompany: boolean
}

const InputSection: React.FC<IInputSectionProps> = ({ requireCompanyData, isPolishCompany }) => {
    const { t } = useTranslation("admin");
    return (
        <>
            <InputHeader text={t("auth.headers.userData") as string} />
            <UserFields />
            {requireCompanyData ? (
                <>
                    <InputHeader text={t("auth.headers.companyData") as string} />
                    <CompanyFields requireCompanyData={requireCompanyData} isPolishCompany={isPolishCompany} />
                    <DepartmentsFields />
                </>
            ) : <DepartmentsFields />}
        </>
    );
};

export default InputSection;